import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Button } from '../components/ui/Button';
import { TrustBadge } from '../components/ui/TrustBadge';
import { ShieldCheckIcon, TargetIcon, ClockIcon } from 'lucide-react';
import { trackPageView, trackClick } from '../utils/analytics';
export function LandingPage() {
  const navigate = useNavigate();
  useEffect(() => {
    trackPageView('landing');
  }, []);
  const handleStartQuiz = () => {
    trackClick('startQuiz');
    navigate('/quiz');
  };
  return <div className="min-h-screen w-full bg-crown-bg flex flex-col" data-id="element-150">
      <Header data-id="element-151" />

      <main className="flex-1" data-id="element-152">
        {/* Hero Section */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-24" data-id="element-153">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-154">
            {/* Left: Text */}
            <div className="space-y-6" data-id="element-155">
              <p className="text-sm sm:text-base text-crown-red font-semibold" data-id="element-156">
                For men who refuse to shave it – but won't gamble their hormones
                to keep it.
              </p>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-crown-text leading-tight" data-id="element-157">
                See Your Hair Retention Score. Complete the Quiz.
              </h1>

              <p className="text-lg sm:text-xl text-crown-body leading-relaxed" data-id="element-158">
                Answer 9 quick questions to find out how much follicle capital
                you still have to work with – and whether a non-hormonal
                red-light protocol can realistically help.
              </p>

              <div className="pt-4" data-id="element-159">
                <Button size="lg" onClick={handleStartQuiz} className="w-full sm:w-auto" data-id="element-160">
                  Start the Quiz (9 Questions, 60 Seconds)
                </Button>
              </div>
            </div>

            {/* Right: Illustration */}
            <div className="flex items-center justify-center" data-id="element-161">
              <div className="w-full max-w-md aspect-square bg-crown-surface border border-crown-border rounded-2xl flex items-center justify-center overflow-hidden" data-id="element-162">
                <img src="https://cdn.magicpatterns.com/uploads/3bXrQYQ9wmsgWhKWCJrrgg/ChatGPT_Image_Feb_26,_2026,_12_32_47_PM.png" alt="CrownControl™ red light therapy cap - FDA Cleared, Clinicians' Choice" className="w-full h-full object-cover" data-id="element-163" />
              </div>
            </div>
          </div>
        </section>

        {/* Trust Bar */}
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12 sm:pb-16 lg:pb-24" data-id="element-164">
          <div className="grid sm:grid-cols-3 gap-4" data-id="element-165">
            <TrustBadge icon={<ShieldCheckIcon className="w-6 h-6" data-id="element-167" />} text="Non-Hormonal Pathway" data-id="element-166" />
            <TrustBadge icon={<TargetIcon className="w-6 h-6" data-id="element-169" />} text="Designed for Early–Moderate Thinning" data-id="element-168" />
            <TrustBadge icon={<ClockIcon className="w-6 h-6" data-id="element-171" />} text="Takes 60 Seconds" data-id="element-170" />
          </div>
        </section>
      </main>

      <Footer data-id="element-172" />
    </div>;
}